var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"submit-success"},[_c('b-row',[_c('b-col',[_c('h4',[_vm._v(_vm._s(_vm.headline))]),(_vm.info !== undefined)?_c('span',[_vm._v(_vm._s(_vm.info))]):_vm._e(),_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }